import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { GETMIGRATIONSTATUSLIST_REQ, GETMIGRATIONDEFAULTOBJECT_REQ, GETMIGRATIONDETAILS_REQ } from "../../../../actions";
import { Popup } from "../../../../../src/components/pop-up";
export default function MigrationStatus(props) {

    const migrationDetails = useSelector((state) => state?.migration?.details);
    
    const migrationStatusResult = useSelector((state) => state?.migration?.migration_status_list);
    const [openModal, setOpenModal] = useState();
    const [errorList, setErrorList] = useState([])
    const urlParams = useRef({});
    const [totalPercentage, setTotalPercentage] = useState(0)
    const [processModule, setProcessModule] = useState()
    const [currentSelectedConfigArray, setcurrentSelectedConfigArray] = useState(props.isReadOnlyView ? migrationStatusResult.data : props.selectedConfigFields)
    const dispatch = useDispatch();
    const pullResult = () => {
        dispatch(GETMIGRATIONSTATUSLIST_REQ({ "migrationID": props.currentMigID,no_loader:true }));
    }

    useEffect(() => {
        dispatch(GETMIGRATIONDEFAULTOBJECT_REQ());
        pullResult()
    }, []);

     useEffect(() => {
            if (props.currentMigID) {
                urlParams.current.id = props.currentMigID;
                dispatch(GETMIGRATIONDETAILS_REQ(urlParams.current));
            }
        }, [props.currentMigID]);

    useEffect(() => {
        if (migrationStatusResult && migrationStatusResult.data) {
            if (props.isReadOnlyView) {
                setcurrentSelectedConfigArray(migrationStatusResult.data)
            }
            if (currentSelectedConfigArray && migrationStatusResult?.data?.length >= currentSelectedConfigArray.length) {
                setcurrentSelectedConfigArray(migrationStatusResult.data)
            }
            const completedCaseCount = migrationStatusResult.data.filter(object => (object.status == "SUCCESS") || (object.status == "FAILED"))
            setProcessModule(migrationStatusResult.data.find((object) => (object.status == "IN PROGRESS")))
            setTotalPercentage(Math.floor((completedCaseCount.length / migrationStatusResult.data.length) * 100))
            let timeout = setTimeout(() => {
                if (totalPercentage == 100) {
                    clearTimeout(timeout)
                } else (
                    pullResult()
                )
            }, 5000)
            return () => clearTimeout(timeout);
        }
    }, [migrationStatusResult]);

    const handlingFaildCase = (currentCase) => {
        setErrorList(currentCase['message']?.split('/n') ||  [])
        if (currentCase.status == "FAILED") {
            setOpenModal(true)
        }
    }

    return (
        <section aria-labelledby="primary-heading"
            className="flex h-full min-w-0 flex-1 flex-col lg:order-last">
            <div className="h-full">
                <div className="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
                    <div className="p-2">
                        <div className="flow-root">
                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                                    <div
                                        className="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                                        <h3 className="text-lg font-semibold leading-6 text-gray-900">
                                            Migration Status
                                        </h3>
                                    </div>
                                    <div className="mt-4 mb-4 gap-x-6 gap-y-6">
                                        <div className="flex justify-between mb-1">
                                            <span
                                                className="text-base font-medium text-black-700 dark:text-white">{processModule && (`${processModule.config_module.toLowerCase()
                                                    .split(' ')
                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                    .join('').replace(/_/g, ' ')} - ${processModule.config_name.toLowerCase()
                                                        .split(' ')
                                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                        .join('').replace(/_/g, ' ')}`)}</span>
                                            <span
                                                className="text-sm font-medium text-black-700 dark:text-white">{totalPercentage}%</span>
                                        </div>
                                        <div
                                            className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                            <div className={`bg-gray-700 h-2.5 rounded-full`}
                                                style={{ "width": `${totalPercentage}%` }}></div>
                                        </div>
                                        <div className="px-2 mt-8">
                                            <div className="sm:flex sm:items-center">
                                                <div className="sm:flex-auto">
                                                    <h1
                                                        className="text-base font-semibold leading-6 text-gray-900">
                                                        Progress
                                                    </h1>
                                                </div>
                                            </div>
                                            <div className="h-full">
                                                <div className="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
                                                    <div className="p-0 h-full ">
                                                        <div className="flow-root h-full">
                                                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 h-full">
                                                                <div className=" h-full inline-block min-w-full py-4 align-middle sm:px-6 lg:px-4">
                                                                    <table
                                                                        className="min-w-full divide-y divide-gray-300  ">
                                                                        <thead className="bg-gray-30">
                                                                            <tr>
                                                                                <th scope="col"
                                                                                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                                                    Module</th>
                                                                                <th scope="col"
                                                                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                                    Configuration</th>
                                                                                <th scope="col"
                                                                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                                    Total Count</th>
                                                                                <th scope="col"
                                                                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                                    Migrated Count</th>
                                                                                <th scope="col"
                                                                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                                    Status</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            className="divide-y divide-gray-200 bg-white">
                                                                            {currentSelectedConfigArray && currentSelectedConfigArray.filter(
                                                                                (obj)=>{
                                                                                    if(!['DATA_MIGRATION','DEPENDENT_DATA'].includes(obj.config_module)) return true;
                                                                                    let isDataMigrationEnabled = migrationDetails && migrationDetails?.data?.length && migrationDetails?.data[0].isDataMigrationEnabled;
                                                                                    return (isDataMigrationEnabled && ['DATA_MIGRATION'].includes(obj.config_module)) || (!isDataMigrationEnabled && ['DEPENDENT_DATA'].includes(obj.config_module));
                                                                                }
                                                                            ).map((object) => (
                                                                                <tr>
                                                                                    <td
                                                                                        className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                                                        <span className="capitalize">{object.config_module
                                                                                            .split(' ')
                                                                                            .join('').replace(/_/g, ' ')
                                                                                            .toLowerCase()
                                                                                        }</span>
                                                                                    </td>
                                                                                    <td
                                                                                        className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                                                        <span className="capitalize">{object.config_name ? object.config_name
                                                                                            .split(' ')
                                                                                            .join('').replace(/_/g, ' ')
                                                                                            .toLowerCase()
                                                                                            : '---'
                                                                                        }</span>
                                                                                    </td>
                                                                                    <td
                                                                                        className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                                                        <span >{object.total_count ? object.total_count : 0}</span>
                                                                                    </td>
                                                                                    <td
                                                                                        className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                                                        {object.migrated_count ? object.migrated_count : 0}
                                                                                    </td>
                                                                                    <td onClick={() => handlingFaildCase(object)}
                                                                                        className={`cursor-pointer whitespace-nowrap px-3 py-4 text-sm font-semibold ${object.status == "SUCCESS" ? 'text-green-600' : object.status == "FAILED" ? 'text-red-600' : object.status == "YET TO START" ? 'text-gray-500' : object.status == "IN PROGRESS" ? 'text-orange-500' : 'text-gray-500'}`}>
                                                                                        <span className="capitalize">{(object.status ? object.status : 'YET TO START').toLowerCase()}</span>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Popup
                modalState={[openModal, setOpenModal]}
                isConfirm={false}
                bodyClass="p-0"
                size="2xl"
                fullHeader={<div className="flex justify-center item-center"><svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 26 26"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="mr-2 h-9 w-9 text-red-400 dark:text-red-200"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                    />
                </svg>
                    <h5>Reason for Failure</h5></div>}
                content={
                    <>
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400 ">
                            <div>
                                <ul>
                                    <table
                                        className="min-w-full divide-y divide-gray-300">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th scope="col"
                                                    className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                    Error In</th>
                                                <th scope="col"
                                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    Reason</th>

                                            </tr>
                                        </thead>
                                        <tbody
                                            className="divide-y divide-gray-200 bg-white">
                                            {errorList.length > 0 && errorList.map(errorMsg => (
                                                <tr>
                                                    <td
                                                        className="whitespace-nowrap px-6 py-4 text-sm text-gray-500  text-left">
                                                        {errorMsg.split(':')[0]}</td>
                                                    <td
                                                        className="whitespace-nowrap px-3 py-4 text-sm text-gray-500  text-left ">
                                                        {errorMsg.split(':')[1]}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </ul>
                            </div>
                        </h3>
                    </>
                }
            />
        </section>
    )
}